export const getPublicityConfigForAdvertType = () => undefined
